import controller from './list.controller';

const template = require('./list.html');

export default {
    bindings: {
        entities: '<',
        entityState: '@'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/entities-list/list.component.js